import React, { ReactElement } from "react";
import { v4 } from "uuid";
import { EventEmitter } from "events";
import { RegistryConfigData } from "@/types/LocalConfig";
import { checkJoyspaceUrl } from "../Joyspace/util";

export interface BrowserViewItem {
  id: string;
  icon?: any;
  originIcon?: any;
  description?: any;
  name?: string;
  link?: string;
  phone?: string;
  company?: string;
  appKey?: string;
  trustedDomains?: string;
  version?: string;
  isThirdApp?: boolean;
  isNewWin?: boolean;
  homeUrl?: string | undefined;
  isFormSubmit?: boolean;
  extraData?: any;
  isApplications?: boolean;
  isNewThirdappAnalysis?: boolean;
  shareStatus?: number;
  ext?: any; // 扩展属性
}

export interface PageMetaData {
  id: string;
  title?: string;
  favicon?: string;
}

export interface BrowserViewConfigData {
  urls: string[];
  allowedHosts: string[];
  partition: string;
}

export interface DefaultPageConfig {
  id: string;
  title: string;
  icon: any;
  body: ReactElement;
}

interface BrowserViewContextProps {
  items: BrowserViewItem[];
  selectedId?: string;
  configData: BrowserViewConfigData;
  registryConfigData: RegistryConfigData;
  onNewWindowOpen?: (url: string, appKey?: string, version?: string) => void;
  onWindowClose?: (id: string) => void;
  onPageMetaDataChanged?: (data: PageMetaData) => void;
  onPageLinkChanged?: (data?: any) => void;
  defaultPage?: DefaultPageConfig;
  notifier: EventEmitter;
  openWebViewModal: (data?: any) => void;
  closeWebViewModal: (data?: any) => void;
  setShareable: (id: string, data?: any) => void;
  shareableObj: any;
  openGroupChat: (data?: any) => void;
  openSingleChat: (data?: any) => void;
  openUserCard: (data?: any) => void;
  openCommonModal: (data?: any) => void;
  openExternal: (data?: any) => void;
  viewImages: (data: string[]) => void;
  webviewModalVisible?: boolean;
  thirdAppListAll?: any;
  ChatviewVisible?: boolean;
  onChangeChatviewVisible?: (visible: boolean) => void;
  openThirdApp?: any;
  setToolMenuVisible?: (visible: boolean) => void;
  toolMenuVisible?: boolean;
}

// @ts-ignore
export const BrowserViewContext = React.createContext<BrowserViewContextProps>({
  items: []
});

// eslint-disable-next-line max-params
export function createBrowserViewItems(
  urls: string[],
  appKey?: string,
  version?: string,
  extraData?: any,
  isFormSubmit?: boolean
) {
  return urls.map((item) => ({ id: v4(), link: item, appKey, version, extraData, isFormSubmit }));
}

// 根据id获取索引 
export function getCurrentActiveIdx(itemsList: any, id: string){
  for(let i = 0; i < itemsList.length; i++){
    if(itemsList[i].id === id){
      return i;
    }
  }
  return -1;
}
// 如果当前文档页面里打开的链接是当前页面的地址，判断是否在新tab打开。false是定位当前页面不做处理。
const openNew = false;
// 获取需要定位到文档的index
export function getJoyspaceIndex(itemsList: any, item: any, id: string){
  const checkJoyspaceUrlItem = checkJoyspaceUrl(item?.link || "");
  if(!checkJoyspaceUrlItem.is && !item.ext){
    return -1;
  }
  if (item && item.link) {
    const pageType = item.ext ? item.ext.joyspacePageType : checkJoyspaceUrlItem.pageType;
    const fileId = item.ext ? item.ext.joyspaceFileId : checkJoyspaceUrlItem.fileId;
    for(let i = 0; i < itemsList.length; i++){
      if(itemsList[i] && (itemsList[i]?.link || "").includes('joyspace')){
        const checkJoyspaceUrlI = checkJoyspaceUrl(itemsList[i].link);
        if(checkJoyspaceUrlI.is || itemsList[i].ext){
          const pageTypeI = itemsList[i].ext ? itemsList[i].ext.joyspacePageType : checkJoyspaceUrlI.pageType;
          const fileIdI = itemsList[i].ext ? itemsList[i].ext.joyspaceFileId : checkJoyspaceUrlI.fileId;
          if(pageTypeI === pageType && fileIdI === fileId){
            return i
          }
        }
      }
    }
  }
  return -1;
}

export function isFullScreen() {
  return !!document.fullscreenElement;
}

export function exitFullScreen() {
  if (isFullScreen()) {
    document.exitFullscreen().then(() => {
      exitFullScreen();
    });
  }
}
